import "./assets/scss/style.scss";

import { QueryClient, QueryClientProvider } from "react-query";
import { UserContext } from "features/account";
import { useContext, useEffect } from "react";

import { BrowserRouter } from "react-router-dom";
import ConditionalRoutes from "./ConditionalRoutes";
import { Worker } from "@react-pdf-viewer/core";
import AppProviders from "app/providers/AppProviders";

const queryClient = new QueryClient();
function App() {
    const { userType } = useContext(UserContext);

    useEffect(() => {
        document.body.classList.add(userType ? userType : "default");
    }, [userType]);

    useEffect(() => {
        let scrollTimeout: NodeJS.Timeout;
        const handleScroll = () => {
            document.body.classList.add("active");
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                document.body.classList.remove("active");
            }, 1000);
        };
        window.addEventListener("scroll", handleScroll, true);
        return () => {
            window.removeEventListener("scroll", handleScroll, true);
        };
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js">
                <BrowserRouter>
                    <AppProviders>
                        <ConditionalRoutes />
                    </AppProviders>
                </BrowserRouter>
            </Worker>
        </QueryClientProvider>
    );
}

export default App;
